<div class="auth-modal">
  <h1 class="auth-title">{{ registerScreen ? (data?.copy?.registerTitle || "Sign up") : "Sign in" }}</h1>
  <p class="auth-subtitle">
    {{ registerScreen
      ? (data?.copy?.registerText || "Create a free account to save your favourite plates and more.")
      : (data?.copy?.loginText || "Sign in to save your favourite plates and more.") }}
  </p>

  <button class="social-btn" (click)="googleLogin()">
    <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
      <path fill="#4285F4" d="M47.5 24.6c0-1.6-.1-3.1-.4-4.6H24v8.7h13.2c-.6 3-2.3 5.5-4.9 7.2v6h7.9c4.6-4.3 7.3-10.6 7.3-17.3z"/>
      <path fill="#34A853" d="M24 48c6.6 0 12.2-2.2 16.2-6l-7.9-6c-2.2 1.5-5 2.3-8.3 2.3-6.4 0-11.8-4.3-13.7-10.1H2.1v6.2C6.1 42.8 14.5 48 24 48z"/>
      <path fill="#FBBC05" d="M10.3 28.2c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7v-6.2H2.1C.7 15.8 0 19.8 0 24s.7 8.2 2.1 11.4l8.2-6.2z"/>
      <path fill="#EA4335" d="M24 9.5c3.6 0 6.8 1.2 9.3 3.6l7-7C36.2 2.2 30.6 0 24 0 14.5 0 6.1 5.2 2.1 12.8l8.2 6.2C12.2 13.8 17.6 9.5 24 9.5z"/>
    </svg>
    Continue with Google
  </button>

  <button class="social-btn" (click)="facebookLogin()">
    <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
      <path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
    Continue with Facebook
  </button>

  <button class="social-btn" (click)="appleLogin()">
    <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 814 1000">
      <path fill="#000000" d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-194.3 126.4-297.5 250.8-297.5 66.1 0 121.2 43.4 162.7 43.4 39.5 0 101.1-46 176.3-46 28.5 0 130.9 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"/>
    </svg>
    Continue with Apple
  </button>

  <p class="social-error" *ngIf="socialError">{{ socialError }}</p>

  <div class="divider-container">
    <div class="divider-line"></div>
    <span class="divider-text">OR</span>
    <div class="divider-line"></div>
  </div>

  <form [formGroup]="registerForm" *ngIf="registerScreen">
    <div class="field-group">
      <label class="field-label">Email address</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput required formControlName="email" name="email" type="email" />
        <mat-error *ngIf="
            registerForm.controls.email.hasError('email') &&
            !registerForm.controls.email.hasError('required')
          ">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="registerForm.controls.email.hasError('required')">
          Email is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label">Password</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput required formControlName="password" name="password" type="password" />
        <mat-error *ngIf="registerForm.controls.password.hasError('required')">
          Password is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label">Repeat password</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput required formControlName="passwordRepeat" name="passwordRepeat" type="password" />
        <mat-error *ngIf="registerForm.controls.passwordRepeat.hasError('required')">
          Repeat password is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="response-errors" *ngIf="registerErrors">
      <ng-container *ngFor="let error of registerErrors">
        <p>{{ error }}</p>
      </ng-container>
    </div>

    <p class="hint">Password requires at least one number, and one special character.</p>

    <button class="primary-btn" (click)="register()">Sign up</button>

    <p class="auth-footer">
      Already have an account?
      <a class="auth-link" (click)="setLoginPage(true)">Sign in</a>
    </p>
  </form>

  <form [formGroup]="loginForm" *ngIf="!registerScreen">
    <div class="field-group">
      <label class="field-label">Email address</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput required formControlName="email" name="email" type="email" />
        <mat-error *ngIf="
            loginForm.controls.email.hasError('email') &&
            !loginForm.controls.email.hasError('required')
          ">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="loginForm.controls.email.hasError('required')">
          Email is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label">Password</label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput required formControlName="password" name="password" type="password"
               (input)="clearLoginError()" (keyup.enter)="login()" />
        <mat-error *ngIf="loginForm.controls.password.hasError('required')">
          Password is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="auth-error" *ngIf="loginError" role="alert" aria-live="assertive">
      <svg class="auth-error-icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
      <span>{{ loginError }}</span>
    </div>

    <button class="primary-btn" (click)="login()">Sign in</button>

    <p class="auth-footer">
      New to Platex?
      <a class="auth-link" (click)="setLoginPage(false)">Create a free account</a>
    </p>
  </form>

  <button class="text-cancel" mat-dialog-close>Cancel</button>
</div>
